import { useEffect, useLayoutEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function hasLocationHash() {
    return window.location.hash.length > 0;
}

export default function useAos() {
    useLayoutEffect(() => {
        if (!hasLocationHash()) {
            window.scrollTo(0, 0);
        }
    }, []);

    useEffect(() => {
        let cancelled = false;
    
        const setupAos = () => {
            if (cancelled) return;
    
            if (!document.body.classList.contains('aos-init')) {
                AOS.init({
                    duration: 800,
                    easing: 'ease-out-cubic',
                    once: true,
                    offset: 120,
                    disable: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
                });
            }
    
            AOS.refresh();
    
            if (!hasLocationHash()) {
                window.scrollTo(0, 0);
                requestAnimationFrame(() => window.scrollTo(0, 0));
            }
        };
    
        // Init immédiat — plus d'attente des images
        setupAos();
    
        // Recalcule les positions quand des images se chargent encore
        const images = document.querySelectorAll('img');
        const onImageLoad = () => {
            if (!cancelled) AOS.refresh();
        };
    
        images.forEach((img) => {
            if (!img.complete) {
                img.addEventListener('load', onImageLoad, { once: true });
                img.addEventListener('error', onImageLoad, { once: true });
            }
        });
    
        return () => {
            cancelled = true;
        };
    }, []);
}
